import type { CheckboxGroupProps as RACheckboxGroupProps } from "react-aria-components";
import { Label, CheckboxGroup as RACheckboxGroup } from "react-aria-components";
import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

const checkboxGroup = tv({
  base: "flex flex-col gap-2",
  slots: {
    label: "mb-1 text-text-primary",
  },
  variants: {
    size: {
      sm: {
        label: "text-sm",
      },
      md: {
        label: "text-base",
      },
      lg: {
        label: "text-lg",
      },
    },
  },
});

export default function CustomCheckboxGroup({
  size,
  children,
  className,
  label: labelProp,
  ...props
}: Omit<RACheckboxGroupProps, "className"> &
  VariantProps<typeof checkboxGroup> & {
    readonly label?: string;
    readonly className?: string;
    readonly children?: React.ReactNode;
  }) {
  const { label, base } = checkboxGroup({ size });
  return (
    <RACheckboxGroup className={base({ className })} {...props}>
      {labelProp && <Label className={label()}>{labelProp}</Label>}
      {children}
    </RACheckboxGroup>
  );
}
